import { siteContent } from "@/data/siteContent";

export const SiteFooter = () => {
  const { brand, footer, navigation } = siteContent;

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-container">
        <div className="footer-top">
          <div className="footer-logo-wrap" data-testid="footer-logo-wrap">
            <img className="footer-full-logo" src={brand.assets.fullLogo} alt={brand.assets.fullLogoAlt} width="240" height="240" loading="lazy" decoding="async" data-testid="footer-full-logo" />
          </div>
          <nav className="footer-nav footer-nav--minimal" aria-label="Footer navigation" data-testid="footer-navigation">
            {footer.links.map((link) => <a key={link.label} href={link.destination} data-testid={`footer-${link.label.toLowerCase()}-link`}>{link.label}</a>)}
            <a href={navigation.memberLogin.destination} data-testid="footer-member-login-link">{navigation.memberLogin.label}</a>
          </nav>
        </div>
        <div className="footer-bottom">
          <p data-testid="footer-boundary-statement">{footer.boundaryStatement}</p>
          <span data-testid="footer-copyright">{footer.copyright}</span>
        </div>
      </div>
    </footer>
  );
};